import React from 'react';
import { ArrowRight } from 'lucide-react';

/**
 * Home page "mini gallery" — 8 tiles rotating across the
 * locally-hosted sparkling-pool-water photos. Each tile uses
 * a stable composite key (img+index) so React can reconcile
 * correctly even if the gallery is re-ordered.
 */
const MiniGallerySection = ({ poolImages, countyName }) => {
  const tiles = [
    { img: poolImages[0], alt: `Modern rectangular pool with water features in ${countyName}` },
    { img: poolImages[1], alt: 'Custom pool with waterfall and paver deck in Florida backyard' },
    { img: poolImages[2], alt: 'Kidney-shaped screen-enclosed pool with palm trees' },
    { img: poolImages[3], alt: 'Screen-enclosed pool with spa, waterfall, and fire pit' },
    { img: poolImages[1], alt: `Sparkling pool water in ${countyName}`, variant: 'b' },
    { img: poolImages[3], alt: 'Luxury inground swimming pool built by American Pools & Spas', variant: 'b' },
    { img: poolImages[0], alt: 'Custom pool with water features by American Pools & Spas', variant: 'b' },
    { img: poolImages[2], alt: `Custom pool design in ${countyName}`, variant: 'b' },
  ];

  return (
    <section className="bg-white py-14 border-t border-gray-200">
      <div className="max-w-[1280px] mx-auto px-5">
        <div className="text-center mb-10">
          <p className="text-[#1e4fa3] tracking-[0.3em] text-xs uppercase mb-2 font-semibold">
            Mini Gallery
          </p>
          <h2 className="font-serif text-3xl md:text-4xl text-[#0b1e4d] font-bold mb-3">
            A Glimpse of Our Work
          </h2>
          <p className="text-gray-600 text-[15px] max-w-2xl mx-auto">
            A small selection of recent custom pool and outdoor living
            projects built for Florida homeowners.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          {tiles.map((item) => (
            <a
              key={`${item.img}-${item.variant || 'a'}`}
              href="https://american-pools.com/orlando-pool-galleries/swimming-pools/"
              target="_blank"
              rel="noopener noreferrer"
              className="group relative block aspect-square overflow-hidden rounded-sm"
              title="View full pool gallery"
            >
              <img
                src={item.img}
                alt={item.alt}
                loading="lazy"
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-[#0b1e4d]/0 group-hover:bg-[#0b1e4d]/35 transition-colors" />
            </a>
          ))}
        </div>

        <div className="text-center mt-10">
          <a
            href="https://american-pools.com/orlando-pool-galleries/swimming-pools/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-[#1e4fa3] hover:bg-[#183d80] text-white font-semibold text-sm tracking-wider uppercase px-8 py-3 rounded-sm transition-colors"
          >
            View Full Gallery <ArrowRight className="w-4 h-4" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default MiniGallerySection;
